export default [
    { //平台宣传列表
        path: '/platformManagement',
        name:'platformManagement',
        meta: { title: '平台宣传列表'},
        component: () => import('../../views/platformManagement/index.vue')
    },
    { //平台宣传添加
        path: '/platformManagement/add',
        name:'platformManagementAdd',
        meta: { title: '平台宣传添加'},
        component: () => import('../../views/platformManagement/add.vue')
    },
    { //平台宣传编辑
        path: '/platformManagement/edit/:id',
        name:'platformManagementEdit',
        meta: { title: '平台宣传编辑'},
        component: () => import('../../views/platformManagement/edit.vue')
    },
    { //平台宣传详情
      path: '/platformManagement/detail/:id',
      name:'platformManagementDetail',
      meta: { title: '平台宣传详情'},
      component: () => import('../../views/platformManagement/detail.vue')
  },
]